import { render, staticRenderFns } from "./leadership.vue?vue&type=template&id=bbdee43a&scoped=true&"
import script from "./leadership.vue?vue&type=script&lang=js&"
export * from "./leadership.vue?vue&type=script&lang=js&"
import style0 from "./leadership.vue?vue&type=style&index=0&id=bbdee43a&lang=less&scoped=true&"
import style1 from "./leadership.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbdee43a",
  null
  
)

export default component.exports